export default __webpack_public_path__ + "static/media/Icon45.ed1e0f88.svg";